export enum ErrorTypes {
  ForetagNotFound = 'foretagNotFound',
  FastighetsinnehavNotFound = 'fastighetsinnehavNotFound',
  Forbidden = 'forbidden',
  ValidationFailed = 'validationFailed',
  LegallyUnavailable = 'legallyUnavailable',
  GatewayTimeout = 'gatewayTimeout',
  UnknownError = 'unknownError',
}
